// @flow

import * as React from 'react';

import {useEffect, useState} from 'react';
import {motion, AnimatePresence} from 'framer-motion';

type SlidingPaneProps = {|
  initial: boolean,
  isLeftPaneVisible: boolean,
  leftPane: React.Node,
  rightPane: React.Node,
|};

export const SlidingPane = ({
  isLeftPaneVisible,
  leftPane,
  rightPane,
  initial,
}: SlidingPaneProps) => {
  const [initScroll, setInitScroll] = useState(true);

  // We do this so regardless of which pane is initially visible, we always start by scrolling from the left.
  useEffect(() => {
    setInitScroll(false);
  }, []);
  let scrollRight = '100vw';
  if (initScroll) {
    scrollRight = '-100vw';
  }
  return (
    <AnimatePresence initial={initial}>
      {isLeftPaneVisible ? (
        <motion.div
          key="leftPane"
          // Why do we transition between relative and absolute positioning?
          // Well, when we position the transition absolutely the component will be on top of any sibling components,
          // giving a nice overlay when we do our animations. However after the animation we want our height to
          // be relative to the parent's height so we don't have any unexpected scrolling.
          initial={{position: 'absolute', x: '-100vw'}}
          animate={{
            x: 0,
            transitionEnd: {
              position: 'relative',
            },
          }}
          exit={{position: 'absolute', x: '-100vw'}}
          transition={{type: 'tween'}}
          style={{
            width: '100%',
            zIndex: 200,
          }}
        >
          {leftPane}
        </motion.div>
      ) : (
        <motion.div
          key="rightPane"
          initial={{position: 'absolute', x: scrollRight}}
          animate={{
            x: 0,
            transitionEnd: {
              position: 'relative',
            },
          }}
          exit={{position: 'absolute', x: '100vw'}}
          transition={{type: 'tween'}}
          style={{
            width: '100%',
            zIndex: 200,
          }}
        >
          {rightPane}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
